import {useParams} from "react-router-dom";

import React, {useEffect, useState} from 'react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {Alert, Button, Divider, Radio, Select, Input} from "antd";
import {weekdayNames} from "@/pages/student/lessons/take/_section/LessonCard";
import {useApiSearchTeacherLessonTimes} from "@/api/absence";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import RenderLoading from "@/components/render-if-loading";
import RenderIf from "@/components/render-if";
import TextArea from "antd/lib/input/TextArea";
import {useApiCreateTeacherReportsModerator, useApiReadTeacherReportsModerator} from "@/api/teacherReports";


function TeacherModeratorPage() {
    const {id} = useParams();

    const [selectedSession, setSelectedSession] = useState('');
    const [reportText, setReportText] = useState('')

    const [timeId, setTimeId] = useState({})
    const [statusOfClass, setStatusOfClass] = useState('ok')


    const {data: sessionsList, isPending: isPendingSessionList} = useApiSearchTeacherLessonTimes({
        lesson_id: id,
    });

    const {mutate: createModeratorReport, isPending: isPendingModerator} = useApiCreateTeacherReportsModerator();
    const {
        data: getModeratorDetail,
        isPending: isPendingGetModeratorDetail,
        refetch
    } = useApiReadTeacherReportsModerator({
        lesson_id: id,
        date: timeId?.date
    })


    useEffect(() => {
        if (!selectedSession && sessionsList?.data?.data?.length > 0) {
            // get end index of sessionList
            const endIndex = sessionsList?.data?.data?.length - 1;
            const end = sessionsList?.data?.data?.at(endIndex);

            setSelectedSession(end.id + '-' + end.class_date);
            setTimeId({time_id: end.id, date: end.class_date})

        }
    }, [selectedSession, sessionsList])


    function handleSaveModerator() {
        let myData = {
            lesson_id: id,
            status: statusOfClass,
            report: reportText,
            date: timeId?.date,
            time_id: timeId?.time_id,
        }

        createModeratorReport(myData, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)
                refetch()
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }
        })
    }

    return (
        <TeacherLayout backTo={sprintf(URLS.teacher.lessons.detail, {id: id})} pageTitle={'گزارش از نظم و نظافت کلاس'}>

            <div>
                <div className="flex flex-col xl:flex-row gap-4 mb-6">
                    <div className="flex-1  rounded-2xl border dark:border-gray-600 border-slate-200 p-4 shadow-sm">

                        <div className="flex gap-2 flex-wrap">

                            <div className={'text-sm'}>برای ثبت گزارش نظافت کلاس لطفا ابتدا تاریخ جلسه را مشخص کنید
                            </div>
                            <RenderLoading loading={isPendingSessionList} skeleton={true}>
                                <Select className={'w-full'}
                                        onChange={(r) => {
                                            setSelectedSession(r);
                                            let index = r.indexOf("-");
                                            let time_id = r.substring(0, index);
                                            let date = r.substring(index + 1);
                                            setTimeId({time_id: time_id, date: date})
                                        }
                                        }
                                        value={selectedSession}
                                        defaultValue={selectedSession}
                                >
                                    {sessionsList?.data?.data.map((s, i) => (
                                        <Select.Option key={'lesson-time' + s.id + '-' + i}
                                                       value={s.id + '-' + s.class_date}

                                        >
                                            <div className={'flex gap-2'}>
                                                <span>
                                                {' جلسه ' + s.session_number + '  '}
                                                </span>
                                                <span>
                                                    {weekdayNames[s.weekday]}
                                                </span>
                                                <span>
                                                    <b>{convertToJalaliWithFormat(s.class_date)}</b>
                                                </span>
                                                <span>
                                                    {' ساعت ' + s.start + '-' + s.end}
                                                </span>
                                                <RenderIf condition={s?.allow_attendance}>
                                                    <span>
                                                        (فعال برای ثبت گزارش نظم و نظافت)
                                                    </span>
                                                </RenderIf>


                                            </div>


                                        </Select.Option>
                                    ))}
                                </Select>
                            </RenderLoading>

                            <Divider type={'horizontal'}/>

                            <RenderIf condition={getModeratorDetail?.data?.data?.id}>
                                <Alert type={'info'}
                                       className={'w-full'}
                                       showIcon={true}
                                       message={'گزارش شما از نظم و نظافت این کلاس در این تاریخ ثبت شده است'}
                                       description={getModeratorDetail?.data?.data?.report}></Alert>
                            </RenderIf>
                            <RenderLoading loading={isPendingGetModeratorDetail} skeleton={true}>
                                <RenderIf condition={!getModeratorDetail?.data?.data?.id}>
                                    <div className={'w-full'}>

                                        <div className={'mb-4'}>
                                    <span className={'text-sm'}>
                                                                            به صورت کلی وضعیت نظم و نظافت محل برگزاری کلاس خود را چگونه توصیف می‌کنید؟
                                    </span>
                                            <br/>
                                            <div className={'text-xl'}>
                                                <Radio.Group>
                                                    <Radio name={'report'} value={'ok'}
                                                           className={'text-green-600 font-bold my-4'}
                                                           onClick={() => setStatusOfClass('ok')}>نظافت انجام
                                                        شده</Radio>
                                                    <br/>
                                                    <Radio name={'report'} value={'nok'}
                                                           className={'text-red-600 font-bold'}
                                                           onClick={() => setStatusOfClass('nok')}>نظافت انجام
                                                        نشده</Radio>
                                                </Radio.Group>
                                            </div>


                                        </div>
                                        <Divider type={'horizontal'}/>
                                        <label>
                                    <span className={'text-sm'}>
در صورت تمایل می‌توانید گزارشی از وضعیت نظم و نظافت محل برگزاری کلاس خود را اینجا بنویسید و برای کارشناسان آموزش ارسال کنید
                                    </span>

                                            <Input.TextArea
                                                onChange={(e) => setReportText(e.target.value)}
                                                rows={5} placeHolder={'گزارش خود را اینجا بنویسید ...'}></Input.TextArea>
                                        </label>
                                    </div>
                                    <div className="flex justify-between w-full">
                                        <div></div>
                                        <div>
                                            <Button type={'primary'} variant={'solid'}
                                                    loading={isPendingModerator}
                                                    onClick={handleSaveModerator}
                                            >
                                                ثبت و ارسال گزارش
                                            </Button>
                                        </div>

                                    </div>
                                </RenderIf>


                            </RenderLoading>

                        </div>
                    </div>

                </div>


            </div>

        </TeacherLayout>
    );
}

export default TeacherModeratorPage;